import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = [
    { label: '关于我们', to: '/about' },
    { label: '用户协议', to: '/about' },
    { label: '隐私政策', to: '/about' },
    { label: '联系我们', to: '/about' },
  ];

  const categories = [
    { label: '恋爱漫画', to: '/category/love' },
    { label: '奇幻漫画', to: '/category/fantasy' },
    { label: '动作漫画', to: '/category/action' },
    { label: '悬疑漫画', to: '/category/thriller' },
    { label: '喜剧漫画', to: '/category/comedy' },
    { label: '剧情漫画', to: '/category/drama' },
  ];

  return (
    <footer className="bg-foreground-900 text-white">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold tracking-tight" style={{ fontFamily: 'var(--font-heading)' }}>
                韩漫<span className="text-rose-400">星球</span>
              </span>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed">
              韩漫星球致力于为广大漫画爱好者提供免费、优质的韩国漫画阅读体验。海量资源，每日更新，下拉式阅读，让您的休闲时光更加充实。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">热门分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.label}>
                  <Link to={cat.to} className="text-sm text-white/60 hover:text-rose-400 transition-colors duration-200 whitespace-nowrap">
                    {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">快捷链接</h4>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-white/60 hover:text-rose-400 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">关注我们</h4>
            <p className="text-sm text-white/60 mb-3">获取最新漫画更新通知和独家福利</p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-rose-500 transition-colors duration-200" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-rose-500 transition-colors duration-200" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-rose-500 transition-colors duration-200" aria-label="QQ" rel="nofollow">
                <i className="ri-qq-line text-sm" />
              </a>
            </div>
            <p className="text-sm text-white/60 mt-4">
              联系邮箱：<a href="mailto:contact@hanman.com" className="hover:text-rose-400 transition-colors">contact@hanman.com</a>
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} 韩漫星球 - 版权所有 | 本站所有漫画资源均来自互联网，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}